module.exports = __webpack_public_path__ + "26333b3884782fdb5f8c0a971f1d2570.woff";